<mat-card class="mat-card--widget">
  <mat-card-content>
    <div class="container">
      <div class="row">
        <div class="col s12 m10">
          <mat-form-field>
            <input matInput placeholder="Search Return Request" (keyup)="search$.next($event)" />
          </mat-form-field>
          <div>
            Please note that the return status is reflective of the submission status. When the status is "In Progress"
            you will be contacted via email with next steps. If you have questions about the status of your return,
            please contact Customer Service using the contact information at the top of the page.
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<h2>Total Returns Requests({{ returns.length }})</h2>
<div *ngFor="let return of returns; let i = index" class="row is-flex">
  <div class="col s12 m4">
    <div class="">Request ID : {{ return.returnRequestId }}</div>
    <div class="">Requested By : {{ return.requestedUser }}</div>
    <div class="">Requested On : {{ return.requestedDate }}</div>
    <div class="">Status : {{ return.status }}</div>
  </div>
  <div class="col s12 m8">
    <div *ngFor="let frame of return.frames" class="row is-flex">
      <div class="col s12 m2">
        <!-- <img src="{{ frame.smallImageUrl }}" /> -->
        <img
          class="frame__image"
          [src]="frame.smallImageUrl"
          onError="this.src='/assets/images/frame-default-sm.png'"
        />
      </div>
      <div class="col s12 m5">
        <div class="text-bold">{{ frame.upc }}</div>
        <div class="mt-5">Return Reason: {{ frame.returnReason }}</div>
        <div class="mt-5" *ngIf="frame.defectReason">Defect Reason: {{ frame.defectReason }}</div>
      </div>
      <div class="col s12 m5">
        <div class="mt-5" *ngIf="frame.patientName">Patient Name: {{ frame.patientName }}</div>
        <div class="mt-5" *ngIf="frame.purchaseDate">Purchase Date: {{ frame.purchaseDate }}</div>
      </div>
    </div>
  </div>
  <hr class="divider" />
</div>
